export const projectData = [
  {
    id: 1,
    image:
      "https://res.cloudinary.com/amedstack/image/upload/v1677550141/projects/Couch_ypyagu.png",
    title: "Couch Surfing(Admin)",
    description: `Couch surfing is a web app where user can find free or nominal fee rooms for enjoying their stay in tours.`,
    category: "MERN",
    demo: "https://couch-surfing.netlify.app/",
    frontEnd: "https://github.com/Aathif-amed/couch_surfing_frontend",
    backEnd: "https://github.com/Aathif-amed/couch_surfing_backend",
  },
  {
    id: 2,
    image:
      "https://res.cloudinary.com/amedstack/image/upload/v1677550142/projects/refurbish_mrsbfx.png",
    title: "Refurbished Store(Admin)",
    description: `Refurbished Store is a ecommerce application where user can find electronics at best rates.`,
    category: "MERN",
    demo: "https://refurbished-store.netlify.app",
    frontEnd: "https://github.com/Aathif-amed/e-commerce_frontend",
    backEnd: "https://github.com/Aathif-amed/e-commerce_backend",
  },
  {
    id: 3,
    image:
      "https://res.cloudinary.com/amedstack/image/upload/v1677550133/projects/Chat_catu9i.png",
    title: "Connect",
    description:
      "Connect is a chat application from which logged in users where able to chat with their friends",
    category: "MERN",
    demo: "https://chat-application-4ad737.netlify.app/",
    frontEnd: "https://github.com/Aathif-amed/chat-application_frontend",
    backEnd: "https://github.com/Aathif-amed/chat_application_backend",
  },
  {
    id: 4,
    image:
      "https://res.cloudinary.com/amedstack/image/upload/v1677550137/projects/Gmail_vicdzk_vfquzy.png",
    title: "Gmail Clone",
    description:
      "Gmail Clone is a web app where user send emails and he/she star the email and can delete emails.",
    category: "MERN",
    demo: "https://gmail-clone-4a3bd.netlify.app/",
    frontEnd: "https://github.com/Aathif-amed/gmail-clone-electron-frontend",
    backEnd: "https://github.com/Aathif-amed/gmail-clone-electron-backend",
  },
  {
    id: 5,
    image:
      "https://res.cloudinary.com/amedstack/image/upload/v1677550144/projects/Youtube_zvmnox_dqm2th.png",
    title: "Youtube Clone",
    description:
      "Youtube clone is a web app were users can watch videos and know about channel details.",
    category: "API",
    demo: "https://youtube-clone-76962a.netlify.app/",
    frontEnd: "https://github.com/Aathif-amed/YouTube_Clone",
  },
  {
    id: 6,
    image:
      "https://res.cloudinary.com/amedstack/image/upload/v1677550133/projects/Weather_z0mrqc.png",
    title: "Weather",
    description:
      "Weather is a web app where users can view weather and other country details using OpenWeather API.",
    category: "API",
    demo: "https://jazzy-conkies-d6ed82.netlify.app",
    frontEnd: "https://github.com/Aathif-amed/Rest_countries_using_Fetch",
  },
  {
    id: 7,
    image:
      "https://res.cloudinary.com/amedstack/image/upload/v1677550135/projects/Web_mu5bzo.png",
    title: "Web Scrapping",
    description:
      "Web Scrapping is a web app where user can check prices of same products in different ecommerce websites.",
    category: "MERN",
    demo: "https://web-scrapping-4a3bd.netlify.app",
    frontEnd: "https://github.com/Aathif-amed/webscrapping-ecommerce-fe",
    backEnd: "https://github.com/Aathif-amed/webscrapping-ecommerce-be",
  },
];

export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "MERN",
  },
  {
    name: "API",
  },
];
